import { useState, useEffect } from 'react';
import networkService from '../services/networkService';
import syncService from '../services/syncService';
import cacheService from '../services/cacheService';

/**
 * Hook für Offline-Status und Sync-Status
 */
export const useOfflineStatus = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [syncStatus, setSyncStatus] = useState({ status: 'idle' });
  const [offlineChanges, setOfflineChanges] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Netzwerk-Status initialisieren
    setIsOnline(networkService.getIsOnline());
    
    // Netzwerk-Listener registrieren
    const handleNetworkChange = (online) => {
      setIsOnline(online);
    };
    
    networkService.addListener(handleNetworkChange);
    
    // Sync-Status-Listener registrieren
    const handleSyncStatusChange = (status) => {
      setSyncStatus(status);
      // Nach erfolgreichem Sync: Offline-Änderungen neu laden
      if (status.status === 'completed') {
        setTimeout(() => {
          loadOfflineChanges();
        }, 500);
      }
    };
    
    syncService.addListener(handleSyncStatusChange);
    
    // Offline-Änderungen laden
    loadOfflineChanges().then(() => {
      setIsInitialized(true);
    });
    
    return () => {
      // Cleanup (falls nötig)
    };
  }, []);

  const loadOfflineChanges = async () => {
    try {
      const changes = await cacheService.getOfflineChanges();
      setOfflineChanges(changes);
    } catch (error) {
      console.error('Error loading offline changes:', error);
    }
  };

  const refreshOfflineChanges = () => {
    loadOfflineChanges();
  };

  return {
    isOnline,
    syncStatus,
    offlineChanges,
    refreshOfflineChanges,
    isOffline: !isOnline,
    isSyncing: syncStatus.status === 'syncing',
    hasOfflineChanges: isInitialized && offlineChanges.length > 0
  };
};

export default useOfflineStatus;
